import { useTranslation } from "react-i18next";
import { Box, Container, Flex, Text } from "@chakra-ui/react";
import { fillLegalDate } from "../../../utils/legalDate";
import LegalVersionNote from "../../legal/LegalVersionNote";
import { legalSupplement, isSupplementKey } from "../../../utils/legalSupplements";

const SectionTitle = ({ children }) => (
    <Text
        fontWeight={700}
        fontSize={'18px'}
        lineHeight={'28px'}
        color={'#1E1517'}
        mt={'8px'}
    >
        {children}
    </Text>
);

const SectionParagraph = ({ children }) => (
    <Text
        fontWeight={400}
        fontSize={'15px'}
        lineHeight={'26px'}
        color={'#3B3033'}
    >
        {children}
    </Text>
);

const PrivacyPolicy = ({ archivedVersion }) => {
    const { t, i18n } = useTranslation("privacypolicy");

    const sections = [
        {
            title: 's1.title',
            paragraphs: ['s1.p1', 's1.p2', 's1.p3'],
        },
        {
            title: 's2.title',
            paragraphs: ['s2.p1', 's2.p2', 's2.p3', 's2.p4', 's2.p5', 's2.p6'],
        },
        {
            title: 's3.title',
            paragraphs: ['s3.p1', 's3.p2', 's3.p3', 's3.p4'],
        },
        {
            title: 's4.title',
            paragraphs: ['s4.p1', 's4.p2', 's4.p3', 's4.p4', 's4.p5'],
        },
        {
            title: 's5.title',
            paragraphs: ['s5.p1', 's5.p2', 's5.p3', 's5.p4', 's5.p5', 's5.p6', 's5.p7'],
        },
        {
            title: 's6.title',
            paragraphs: ['s6.p1', 's6.p2', 's6.p3', 's6.p4', 's6.p5'],
        },
        {
            title: 's7.title',
            paragraphs: ['s7.p1', 's7.p2', 's7.p3'],
        },
        {
            title: 's8.title',
            paragraphs: ['s8.p1'],
        },
        {
            title: 's9.title',
            paragraphs: ['s9.p1', 's9.p2'],
        },
        {
            title: 's10.title',
            paragraphs: ['s10.p1'],
        },
        {
            title: 's11.title',
            paragraphs: ['s11.p1'],
        },
    ];

    return (
        <>
            <Box w={'full'} fontFamily="body">
                <Container maxW={'7xl'} py={'64px'}>
                    <Flex flexDirection={'column'} gap={'8px'}>

                        {/* Nagłówek strony */}
                        <Text
                            fontWeight={700}
                            fontSize={'26px'}
                            lineHeight={'38px'}
                            color={'#1E1517'}
                            textAlign={'center'}
                            mb={'4px'}
                        >
                            {t('page_title')}
                        </Text>

                        {/* Metadane */}
                        <Flex gap={'16px'} flexDirection={{ base: 'column', sm: 'row' }} mb={'32px'}>
                            <Text fontWeight={400} fontSize={'13px'} color={'#6E6064'}>
                                {fillLegalDate(t('effective_date'), 'privacypolicy', archivedVersion)}
                            </Text>
                            <Text fontWeight={400} fontSize={'13px'} color={'#6E6064'}>
                                {fillLegalDate(t('version'), 'privacypolicy', archivedVersion)}
                            </Text>
                        </Flex>

                        <LegalVersionNote doc="privacypolicy" archivedVersion={archivedVersion} />
                        {/* Separator */}
                        <Flex w={'full'} h={'1px'} bg={'#ECE4E4'} mb={'32px'} />

                        {/* Sekcje 1–11 */}
                        <Flex gap={'32px'} flexDirection={'column'} w={'full'}>
                            {sections.map((section) => (
                                <Flex key={section.title} flexDirection={'column'} gap={'12px'}>
                                    <SectionTitle>
                                        {t(section.title)}
                                    </SectionTitle>
                                    {section.paragraphs.filter((pKey) => !archivedVersion || !isSupplementKey('privacypolicy', pKey)).map((pKey) => (
                                        <SectionParagraph key={pKey}>
                                            {t(pKey, { defaultValue: legalSupplement('privacypolicy', i18n.language, pKey) })}
                                        </SectionParagraph>
                                    ))}
                                </Flex>
                            ))}
                        </Flex>

                    </Flex>
                </Container>
            </Box>
        </>
    );
};

export default PrivacyPolicy;
